<script>
const appConfig = require('./app.config')
import i18n from '@plugins/i18n'
import jQuery from 'jquery'
window.jQuery = jQuery

function translateTitle(title){
  if (title.includes('/')){
    let arr_text = title.split('/')
    for (let j = 0; j < arr_text.length; j++) {
      arr_text[j] = i18n.t('pages.'+arr_text[j]);
    }
    return arr_text.join(" › ")
  } else {
    return title ? i18n.t('pages.'+title) : title
  }
}

export default {
  data() {
    return {
      title: ''
    }
  },
  methods: {
    setTitle: function(title) {
      this.title = title
    }
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return `${translateTitle(title) || appConfig.TITLE} | ${appConfig.TITLE}`
    }
  },
  watch: {}
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
    <notifications group="foo" classes="custom-vue-notification" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
  // Allow element/type selectors, because this is global CSS.
  // stylelint-disable selector-max-type, selector-class-pattern

  // Design variables and utilities from src/design.
  @import '@design';
</style>
